<template>
  <v-empty-state headline="Whoops, 404" 
  title="Página no encontrada" 
  text="La página a la que quieres acceder no existe." 
  image="https://cdn.vuetifyjs.com/docs/images/components/v-empty-state/teamwork.png" />
</template>
<script setup></script>